import { FolderType } from './useAssetPicker';

/**
 * 시스템 폴더 타입별 i18n 번역 키 매핑
 * 백엔드에서 folder.name으로 'folder.type.xxx' 형식의 키가 전달됨
 */
export const FOLDER_TYPE_TRANSLATION_KEY: Record<FolderType, string> = {
  [FolderType.ROOT]: 'folder.type.root',
  [FolderType.PROJECT]: 'folder.type.project',
  [FolderType.USER_ASSET]: 'folder.type.user_asset',
  [FolderType.SCRIPT]: 'folder.type.script',
  [FolderType.INSIGHT]: 'folder.type.insight',
  [FolderType.CUSTOM]: '',
};
